import {NSelectComponent} from "./n-select/n-select.component";
import {NOptionComponent} from "./n-select/n-option/n-option.component";

export {NButtonComponent} from "./n-button/n-button.component";
export {NCheckboxComponent} from "./n-checkbox/n-checkbox.component";
export {NRadioComponent} from "./n-radio/n-radio.component";
export {NInputComponent} from "./n-input/n-input.component";
export {NTextareaComponent} from "./n-textarea/n-textarea.component";
export {NSelectComponent} from "./n-select/n-select.component";
export {NIconComponent} from "./n-icon/n-icon.component";
export {NOptionComponent} from "./n-select/n-option/n-option.component";

export * from "./dropdown/public_exports";

export {NToggleComponent} from "./n-toggle/n-toggle.component";
export {NTabComponent} from "./n-tabset/n-tab/n-tab.component";
export {NTabsetComponent} from "./n-tabset/n-tabset.component";
export {NTimePickerComponent, NTimePickerValue, NTimePickerAutocompleteItem, pad} from "./n-time-picker/n-time-picker.component";
export {NInputCalendarComponent} from "./n-input-calendar/n-input-calendar.component";
export {NControlGroupComponent} from "./n-control-group/n-control-group.component";
export {NInputCalendarPopoverComponent} from "./n-input-calendar/n-input-calendar-popover/n-input-calendar-popover.component";
export {NHintComponent} from "./n-hint/n-hint.component";
export {NControlComponent} from "./n-control/n-control.component";
export {NDateTimePickerComponent} from "./n-date-time-picker/n-date-time-picker.component";

export interface NInputErrorMessages {
  [key: string]: string;
}

export interface NControlsValidationErrors {
  [key: string]: NFrameworkValidationError;
}

export interface IControlWithErrors {
  setErrors(errors: NControlsValidationErrors);
}

export type NFrameworkValidationError = NFrameworkValidityError | any;

export class NFrameworkValidityError {
  type: string;
  message: string;
  code: string;
  data: any;
}
